export default "__VITE_ASSET__l3c8f3E$__"